import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import ImagelistNode from './ImagelistNode'
import ImagelistConfig from './ImagelistConfig'

registerNodeType({
  type: 'IMAGELIST',
  label: 'Image List',
  icon: ICONIFY.IMAGELIST,
  color: '#5C6BC0',
  hasOptions: false,
  excludeFields: ['inputMode', 'inputRegex', 'minSize', 'maxSize'],
  defaults: {},
  nodeComponent: ImagelistNode,
  configComponent: ImagelistConfig,
})
